import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      Admin Site
    </div>
  );
}

export default App;
